export const REQUESTS_QUERY_KEY = "requests";

export const REQUEST_ACTIVITIES_QUERY_KEY = "requestsActivities";
export const REQUESTS_NAVIGATION_QUERY_KEY = "requestsNavigation";
export const REQUEST_LIST_INFO_QUERY_KEY = "requestListInfo";

export const PAGE_SIZE = 20;
export const NAVIGATION_PAGE_SIZE = 100;

export const PERMISSIONS = {
  requestsList: "PickupRequests.PickupRequestList",
  requestsListExport: "PickupRequestList.ExportPickupRequests",
  requestsListAddRequest: "PickupRequestList.AddPickupRequest",
  requestDetails: "PickupRequests.PickupRequestDetails",
  requestListAssign: "PickupRequestList.AssignToTheUser",
  requestListEditPriority: "PickupRequestList.EditPriority",
  requestEdit: "PickupRequestDetails.EditPickupRequest",
  requestDetailsAssign: "PickupRequestDetails.ChangeAssignment",
  requestApprove: "PickupRequestDetails.ApprovePickupRequest",
  requestSend: "PickupRequestDetails.SendPickupRequestToCarrier",
  requestResend: "PickupRequestDetails.ResendPickupRequestToCarrier",
  requestInvalidate: "PickupRequestDetails.InvalidatePickupRequest",
  requestFlag: "PickupRequestDetails.FlagPickupRequest",
  requestHistory: "PickupRequestDetails.ViewPickupRequestHistory",
  requestNotes: "PickupRequestDetails.SeeListOfNotes",
  requestHistoryExport: "PickupRequestDetails.ExportHistoryRecords",
  requestAddNote: "PickupRequestDetails.AddNewNote",
  requestNotesExport: "PickupRequestDetails.ExportNotes",
  requestDocuments: "PickupRequestDetails.ManagePickupRequestDocuments",
  requestForceComplete: "PickupRequestDetails.ForceCompletePickupRequest",
  participantProfile: "Participants.ParticipantProfile",
  transactionDetails: "TransactionManagement.TransactionDetailsPage",
};
